import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { gsap, Power2 } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

import hero1 from '../../images/slider/sqaure_shape.png'
import hero2 from '../../images/service-bg.png'
import hero3 from '../../images/slider/side-shape.png'
import hero4 from '../../images/slider/side-shape.png'

gsap.registerPlugin(ScrollTrigger);


const Hero3 = () => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const getHeight = () => {
        if (windowWidth >= 992) return "800px";
        if (windowWidth >= 768) return "500px";
        return "350px";
    };

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }


    return (
        <section className="hero-section-s3" style={{height: getHeight()}}>
            <div className="container">
                <div className="hero-wrap">
                    <div className="title">
                        <div className="scroll-text-animation" data-animation="fade_from_bottom" style={{paddingLeft: window.innerWidth >= 768 ? "" : "15px", paddingRight: window.innerWidth >= 768 ? "" : "15px", fontWeight:"700" }}>
                            {/* <h2>클립에듀 서비스 소개.</h2> */}
                            <h3 style={{color:"#313337", fontSize: window.innerWidth >= 768 ? "32px" : "20px", marginBottom: window.innerWidth >= 768 ? "-15px" : "10px", fontWeight:"700", lineHeight: window.innerWidth >= 768 ? "50px" : "1.5", marginTop: window.innerWidth >= 768 ? "-230px" : ""}}>
                                환경기술에 대한 확고한 신념을 { window.innerWidth < 400 && <br /> } 바탕으로 { (window.innerWidth > 400 && window.innerWidth < 768) && <br /> } 폐수재이용과 { window.innerWidth >= 1200 ? <br /> : " " }
                                폐기물 재활용 분야에서 독보적인 { window.innerWidth >= 1200 ? <br /> : " " }
                                전문역량을 { window.innerWidth < 400 && <br /> } 확보하고 있습니다.
                            </h3>
                            <div className="p-style-s2">
                                <p style={{color:"#000", fontSize: window.innerWidth >= 768 ? "20px" : "16px", fontWeight:"400", lineHeight: window.innerWidth >= 768 ? "30px" : "1.5", width:"200%"}}>
                                    항상 고객사와의 상생과 신뢰를 통하여 고객가치를 { window.innerWidth < 400 && <br /> } 높여 { window.innerWidth > 400 && <br /> }
                                    나가는 일에 최선을 다하고 있습니다.
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            {/* <div className="bg-shape">
                <img src={hero1} alt="" />
            </div> */}
            {/* scroll-text-animation */}
            <div
                className="bg-image"
                style={{
                    maskImage: `url(${hero3})`,
                    WebkitMaskImage: `url(${hero4})`,
                }}
            >
                <img src={hero2} alt="" />
            </div>
            {/* <div className="shape"></div>
            <div className="shape-2"></div> */}

        </section>
    );
};

export default Hero3;
